import { StrictMode } from "react";
import { I18nextProvider } from "react-i18next";

import { LazyHotReloadIndicator, LazyReactAxe, PageViewLogger } from "@shared/components";
/* eslint-disable @fullscript/cross-reference */
import type { Flipper } from "@shared/types/flipper";
import { WellevateAuthWrapper } from "@unauthenticated/shared/components/WellevateAuthWrapper";
import { ErrorBoundary } from "@unauthenticated/signupSignin/components";
import { i18n } from "@unauthenticated/wellevateAuthorize/practitioners/locales/i18n";

import { Providers } from "../../components";
import { MigrationAccountCreationFlow } from "../components/MigrationAccountCreationFlow";

interface Props {
  emailRegex: string;
  currentCountry: string;
  treatmentPlanTerm: string;
  flippers: Flipper[];
  analyticsAnonymousId: string;
}

const WellevateAuthorizePage = ({
  emailRegex,
  currentCountry,
  treatmentPlanTerm,
  flippers,
  analyticsAnonymousId,
}: Props) => {
  return (
    <StrictMode>
      <Providers
        emailRegex={emailRegex}
        country={currentCountry}
        treatmentPlanTerm={treatmentPlanTerm}
        analyticsAnonymousId={analyticsAnonymousId}
      >
        <I18nextProvider i18n={i18n}>
          <ErrorBoundary {...{ flippers }}>
            <WellevateAuthWrapper hasWideContent>
              <PageViewLogger isUnauth>
                <MigrationAccountCreationFlow />
              </PageViewLogger>
            </WellevateAuthWrapper>
          </ErrorBoundary>
        </I18nextProvider>
        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </Providers>
    </StrictMode>
  );
};

export { WellevateAuthorizePage };
